export const measurementUnitNP = 'N/P';
